<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title
      >{{'Presença ' | translate}} {{'visitantes' | translate}}</ion-title
    >
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <div class="div-top">
    <ion-note slot="start">
      <i class="fas fa-user-clock div-icon"></i>
    </ion-note>

    <ion-label class="color-title">
      {{'Visitantes presentes' | translate}}
    </ion-label>
  </div>

  <div>
    <ion-grid class="grid">
      <ion-row *ngFor="let participante of participantes;">
        <ion-col size="2">
          <ion-avatar>
            <img [src]="participante.foto | image:' '" />
          </ion-avatar>
        </ion-col>

        <ion-col size="10">
          <ion-toggle
            [enableOnOffLabels]="true"
            class="bold-1"
            [ngModel]="participante.presenca == 1"
            justify="space-between"
            [disabled]="readOnly"
            (ngModelChange)="salvarIndividual(participante)"
          >
            <span class="toggle-label">
              {{ participante.nome }}
            </span>
          </ion-toggle>
        </ion-col>

        <ion-item-divider></ion-item-divider>
      </ion-row>

      <ion-row class="ion-justify-content-center" *ngIf="participantes.length">
        <ion-col size="7">
          <ion-button class="btn-default" expand="block" (click)="proximo()">
            {{ 'Próximo' | translate }}

            <i class="fa-regular fa-arrow-right"></i>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list *ngIf="!participantes.length">
      <sem-registro></sem-registro>
    </ion-list>
  </div>
</ion-content>
